import { formatNumber } from "@";

const CardFooter = ({ number = 0, percent = 0, prefix, searchDuration }) => {
  const formattedNumber = formatNumber(number);
  const formattedPercent = formatNumber(Math.abs(percent)?.toFixed(1));
  const isUp = percent > 0;
  const isDown = percent < 0;
  const percentSign = isUp ? "+" : isDown ? "-" : "";

  const tone = isUp
    ? "bg-emerald-50 text-emerald-700 ring-emerald-100 dark:bg-emerald-950/40 dark:text-emerald-300 dark:ring-emerald-900/40"
    : isDown
      ? "bg-rose-50 text-rose-700 ring-rose-100 dark:bg-rose-950/40 dark:text-rose-300 dark:ring-rose-900/40"
      : "bg-gray-50 text-gray-600 ring-gray-100 dark:bg-gray-800 dark:text-gray-400 dark:ring-gray-700";

  const comparisonLabel =
    searchDuration == 0
      ? "باليوم السابق"
      : searchDuration == 1
        ? "بالأسبوع السابق"
        : searchDuration == 2
          ? "بآخر 14 يوم"
          : searchDuration == 3
            ? "بالشهر السابق"
            : searchDuration == 4
              ? "بأخر 3 شهور"
              : searchDuration == 5
                ? "بالعام السابق"
                : "";

  return (
    <div className="items-end justify-between sm:flex">
      <h2 className="dark:text-gray-300">
        <span className="me-1 text-2xl font-bold tracking-tight text-gray-900 dark:text-gray-100">
          {formattedNumber}
        </span>
        {prefix && (
          <span className="text-sm font-medium text-gray-500 dark:text-gray-400">
            {prefix}
          </span>
        )}
      </h2>

      <div className="mt-2 sm:mt-0 sm:text-end">
        <span
          className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-sm font-bold tabular-nums ring-1 ${tone}`}
        >
          {(isUp || isDown) && (
            <svg
              className={`h-3 w-3 ${isDown ? "rotate-180" : ""}`}
              fill="none"
              viewBox="0 0 12 12"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 9.5V2.5M6 2.5L2.5 6M6 2.5L9.5 6"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
          <span>
            {percentSign}
            {formattedPercent}%
          </span>
        </span>
        {comparisonLabel && (
          <p className="mt-1 text-[11px] text-gray-500 dark:text-gray-400 sm:text-xs">
            مقارنة {comparisonLabel}
          </p>
        )}
      </div>
    </div>
  );
};

export default CardFooter;
